import { useStaticQuery, graphql } from 'gatsby';
import useTransformMenus from './use-transform-menus';

const useMenuItems = () => {
  const { strapiMenus } = useStaticQuery(graphql`
    fragment MenuMenuItems on StrapiMenusMenusItem {
      id
      externalpage {
        id
        externalLink
        externalTitle
      }
      page {
        id
        slug
        title
      }
      homepage
      subpages {
        id
        slug
        title
      }
      icon {
        localFile {
          childImageSharp {
            gatsbyImageData(
              layout: FIXED
              width: 20
              quality: 100
              placeholder: BLURRED
            )
          }
        }
      }
    }

    query UseStrapiMenusUseMenuItems {
      strapiMenus: allStrapiMenusMenus(
        filter: {
          position: {
            eq: "MainMenu"
          }
        }
      ) {
        nodes {
          id
          title
          position
          items {
            ...MenuMenuItems
          }
        }
      }
    }
  `);
  const menus = useTransformMenus(strapiMenus);

  return {
    menuItems: menus[0]?.items,
    menus,
  };
};

export default useMenuItems;
